import { theme } from '@chakra-ui/theme';

export const INPUT_PARTS = theme.components.Input.parts;
